import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authApi } from '../api/auth';
import './Auth.css';

const ForgotPassword: React.FC = () => {
  const [identifier, setIdentifier] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);
    try {
      const { data } = await authApi.forgotPassword(identifier.trim());
      setMessage(data.message || 'Jeśli konto istnieje, wysłaliśmy e-mail z linkiem do resetu hasła.');
    } catch (err: any) {
      const status = err?.response?.status;
      if (status === 429) {
        setError('Zbyt wiele prób. Spróbuj ponownie za chwilę.');
      } else {
        setError('Nie udało się wysłać wiadomości. Spróbuj ponownie.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <form className="auth-card" onSubmit={handleSubmit}>
        <h1 className="auth-title">Reset hasła</h1>
        <p className="auth-subtitle">
          Podaj swoją nazwę użytkownika lub adres e-mail. Wyślemy link do ustawienia nowego hasła.
        </p>

        {message && <div className="auth-info">{message}</div>}
        {error && <div className="auth-error">{error}</div>}

        <div className="form-group">
          <label className="form-label">E-mail</label>
          <input
            className="form-input"
            type="text"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            required
            autoFocus
          />
        </div>

        <button className="btn btn-primary auth-btn" type="submit" disabled={loading || !identifier.trim()}>
          {loading ? 'Wysyłanie...' : 'Wyślij link resetujący'}
        </button>

        <p className="auth-footer">
          <Link to="/login">Wróć do logowania</Link>
        </p>
      </form>
    </div>
  );
};

export default ForgotPassword;
